import BaseEntity from './BaseEntity';
import Issue from './Issue';
export default class CommitFile extends BaseEntity {
    constructor(data) {
        super();
        this.messages = [];
        this.source = this.parseProperty(data, 'source');
        this.messages = this.parseProperty(data, 'messages').map(message => new Issue(message));
    }
}
